<div class="container">
  <!-- Logo and loader section -->
  <div class="logo-container">
    <!-- Display the logo -->
    <img class="logo" src="../assets/VERSUS.png" />

    <!-- Display challenge title or a message if challenge is not found -->
    <div *ngIf="challengeId != null">
      <h3>You were invited to a challenge!</h3>
      <h1>{{ challengeTitle }}</h1>

      <p *ngIf="isInAppBrowser()">
        Open this challenge in the app for the best experience.
      </p>
    </div>

    <!-- Join challenge button if challengeId is present -->
     <button class="join-button" (click)="openInApp()">
      Open in App
    </button>

    <!-- TODO DELETE när firebase dynamic links är bortrensat
    <div *ngIf="dynamicLink != ''">
      <a
        class="join-button"
        *ngIf="challengeId != null"
        target="_blank"
        [href]="dynamicLink"
      >
        Join Challenge
      </a>
    </div> -->

    <img class="piedestal" src="../assets/blue_piedestal.png" />
  </div>

  <!-- Download links section -->
  <div class="download-container">
    <a
      href="https://apps.apple.com/us/app/versus-fitness-challenges/id6740733976"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        class="download"
        src="../assets/download_app_store.svg"
        alt="Download on the App Store"
      />
    </a>
    <!-- <img class="download" src="../assets/download_google_play.png" /> -->
  </div>
</div>
